<template>
  <div class="page__data_center b-page" style="padding-top: 10px;">
    <div style="background-color:white; overflow: hidden; padding: 10px">
      <div>
        <p class="text-primary" style="font-weight: bold; font-size: 20px">{{ $t('menu.ads_insights') }}</p>
      </div>

      <el-row style="margin-top: 20px;">
        <el-col :sm="18">
          <div style="display: inline-block; margin-right: 10px">
            <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                         :disabled="loading.get_data"></shop-select>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top: 30px;">
        <strong style="font-size: 16px">{{ $t('base.basic_info') }}</strong>

        <el-row style="padding-top: 20px">
          <el-col :sm="6">
            <div class="shopee-cover" :style="{ backgroundImage: `url(${cover})` }">
            </div>
          </el-col>
          <el-col :sm="18" style="padding-left: 30px">
            <table class="table">
              <tr>
                <td>
                  <span class="shopee-overview-item-label"><i class="el-icon-s-shop"></i> {{
                      $t('base.products')
                    }}: </span>
                  <span class="shopee-overview-item-value-1"> {{ item_count }}</span>
                </td>
                <td>
                  <span class="shopee-overview-item-label"><i class="el-icon-circle-close"></i>
                    {{ $t('center.cancel_order_rate') }}: </span>
                  <span class="shopee-overview-item-value-1"> {{ cancel_rating }}%</span>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 5px"></div>
                </td>
                <td>
                  <div style="height: 5px"></div>
                  <el-tag v-if="+cancel_rating > 10" type="danger" effect="dark" size="medium">
                    {{ $t('center.improve_conversions_rate') }}
                  </el-tag>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="height: 30px"></div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="shopee-overview-item-label"><i class="el-icon-chat-square"></i>
                    {{ $t('center.chat_response_rate') }}:
                  </div>
                  <div class="shopee-overview-item-value-1">
                    {{ display_response_rate }}%
                  </div>
                </td>
                <td>
                  <div class="shopee-overview-item-label"><i class="el-icon-star-on"></i>
                    {{ $t('center.shop_rating') }}:
                  </div>
                  <div class="shopee-overview-item-value-1">
                    {{ rating_star.toFixed(1) }} ({{ m__short_value(rating_sum) }} {{ $t('center.ratings') }})
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 5px"></div>
                  <el-tag v-if="+display_response_rate < 90" type="danger" effect="dark" size="medium">
                    {{ $t('center.should_respond_chat') }}
                  </el-tag>
                </td>
                <td>
                  <div style="height: 5px"></div>
                  <el-tag v-if="+rating_star < 5" type="danger" effect="dark" size="medium">
                    {{ $t('center.ask_for_positive') }}
                  </el-tag>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="height: 30px"></div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="shopee-overview-item-label"><i class="el-icon-time"></i>
                    {{ $t('center.response_time') }}:
                  </div>
                  <div class="shopee-overview-item-value-1">{{ response_time_value }}</div>
                </td>
                <td>
                  <div class="shopee-overview-item-label"><i class="el-icon-star-on"></i>
                    {{ $t('center.shop_rating') }}:
                  </div>
                  <div class="shopee-overview-item-value-2">
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style="height: 5px"></div>
                  <el-tag type="danger" effect="dark" size="medium">
                    {{ $t('center.respond_customers_faster') }}
                  </el-tag>
                </td>
                <td>
                  <div style="height: 5px"></div>
                  <div style="padding-left: 5px">
                    <div class="shopee-overview-rating">5 Sao ({{ rating_count[0] | currency }})</div>
                    <div class="shopee-overview-rating">4 Sao ({{ rating_count[1] | currency }})</div>
                    <div class="shopee-overview-rating">3 Sao ({{ rating_count[2] | currency }})</div>
                    <div class="shopee-overview-rating">2 Sao ({{ rating_count[3] | currency }})</div>
                    <div class="shopee-overview-rating">1 Sao ({{ rating_count[4] | currency }})</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="height: 30px"></div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="shopee-overview-item-label"><i class="el-icon-money"></i>
                    {{ $t('center.pricing_segment') }}:
                  </div>
                  <div class="shopee-overview-item-value-2">
                    {{ min_price | currency }} - {{ max_price | currency }}
                  </div>
                </td>
                <td>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </el-row>
    </div>

    <div style="background-color:white; overflow: hidden; padding: 10px; margin-top: 10px; min-height: 400px">
      <el-row>
        <strong style="font-size: 16px">{{ $t('base.products_info') }}</strong>

        <div style="margin-top: 30px; margin-left: 30px; display: flex; flex: 1;  -webkit-box-flex: 1; -ms-flex: 1;">
          <div style="min-width: 200px">
            <div style="display: flex; -webkit-box-align: baseline; -ms-flex-align: baseline; align-items: baseline;">
              <span class="point-1"></span>
              <div style="display: inline-block">
                <span style="font-size: 14px; font-weight: 600">{{ $t('center.improvable') }}</span><br>
                <span style="font-size: 26px; font-weight: 600; color: rgb(251, 115, 75)">
                  {{ product_list.filter(i => i.label.length).length }}
                </span>
              </div>
            </div>
            <div
              style="display: flex; -webkit-box-align: baseline; -ms-flex-align: baseline; align-items: baseline; margin-top: 20px">
              <span class="point-2"></span>
              <div style="display: inline-block">
                <span style="font-size: 14px; font-weight: 600">{{ $t('center.high_quality') }}</span><br>
                <span style="font-size: 26px; font-weight: 600;">
                  {{ product_list.filter(i => !i.label.length).length }}
                </span>
              </div>
            </div>
          </div>
          <div style="padding: 0 100px; min-width: 800px">
            <p v-if="m__get_optimizer_rating()" style="font-size: 26px; font-weight: 600" class="text-danger">
              {{ $t('center.more_x_products_need_to_improve', {x: m__get_optimizer_rating()}) }}
            </p>
            <p v-else style="font-size: 26px; font-weight: 600" class="text-success">
              {{ $t('center.very_good') }}
            </p>
            <p style="font-size: 14px; font-weight: 600">
              {{ $t('center.note_1') }}
              <br>
              {{ $t('center.note_2') }}
            </p>
            <br>
            <el-tag v-if="+m__get_optimizer_rating()" type="danger" effect="dark" size="medium">
              {{ $t('center.note_3') }}
            </el-tag>
          </div>
        </div>

        <el-tabs style="margin-top: 40px" v-model="product_tab">
          <el-tab-pane :label="`${$t('center.product_tab_1')} (${m__get_tab_length('title')})`"
                       name="title"></el-tab-pane>
          <el-tab-pane :label="`${$t('center.product_tab_2')} (${m__get_tab_length('description')})`"
                       name="description"></el-tab-pane>
          <el-tab-pane :label="`${$t('center.product_tab_3')} (${m__get_tab_length('category')})`"
                       name="category"></el-tab-pane>
          <el-tab-pane :label="`${$t('center.product_tab_4')} (${m__get_tab_length('image')})`"
                       name="image"></el-tab-pane>
          <el-tab-pane :label="`${$t('center.product_tab_5')} (${m__get_tab_length('shipping')})`"
                       name="shipping"></el-tab-pane>
        </el-tabs>

        <el-table :data="c__product_display_list">
          <el-table-column :label="$t('base.product')" width="80px" fixed="left">
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images[0])" alt="logo"
                   style="width:56px; height: 56px;">
            </template>
          </el-table-column>
          <el-table-column show-tooltip-when-overflow fixed="left">
            <template slot-scope="scope">
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.id}`, shop)">
                {{ scope.row.name }}
              </a>
            </template>
          </el-table-column>
          <template v-if="product_tab === 'seo'">
            <el-table-column :label="$t('center.suggest_seo_name')" show-tooltip-when-overflow fixed="left">
              <template slot-scope="scope">
                {{ scope.row.seo }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.optional')" width="150px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="m__confirm_update_product_name(scope.row)">
                  <strong class="text-primary">{{ $t('center.update_by_suggested') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column :label="$t('center.last_updated')">
              <template slot-scope="scope">
                {{ scope.row.extra_data.mtime * 1000 | moment('DD-MM-YYYY HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('center.recommend')">
              <template slot-scope="scope">
                <div v-if="product_tab === 'title'">
                  {{ scope.row.extra_data['title'].current_len }} / {{ scope.row.extra_data['title'].suggest_len }}
                </div>

                <div v-if="product_tab === 'category'">
                  {{ $t('center.update_by_same_category') }}
                </div>

                <div v-if="product_tab === 'description'">
                  {{ scope.row.extra_data['description'].current_len }} /
                  {{ scope.row.extra_data['description'].suggest_len }}
                </div>

                <div v-if="product_tab === 'image'">
                  {{ scope.row.extra_data['image'].current_images.length }} /
                  {{ scope.row.extra_data['image'].suggest_len }}
                </div>

                <div v-if="product_tab === 'shipping'">
                  {{ $t('center.edit_size') }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.optional')" width="150px">
              <template slot-scope="scope">
                <el-button type="text" size="mini"
                           @click="open_link(`https://banhang.shopee.vn/portal/product/${scope.row.id}/`)">
                  <strong class="text-primary">{{ $t('base.update_products') }}</strong>
                </el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="total, prev, pager, next" :total="c__product_filter_list.length"></el-pagination>
      </el-row>
    </div>

    <div style="background-color:white; overflow: hidden; padding: 10px; margin-top: 10px; min-height: 400px">
      <strong style="font-size: 16px">{{ $t('center.ads_effectiveness') }}</strong>
      <div style="margin-top: 30px; padding-left: 30px">
        <table class="table">
          <tr>
            <td>
              <span class="shopee-overview-item-label"><i class="el-icon-s-order"></i>
                {{ $t('center.ongoing_campaigns') }}: </span>
              <span class="shopee-overview-item-value-1"> {{ m__get_ongoing_campaign() }}</span>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div style="height: 30px"></div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="shopee-overview-item-label"><i class="el-icon-chat-square"></i>
                {{ $t('center.ongoing_campaigns_with_daily_budget') }}:
              </div>
              <div class="shopee-overview-item-value-1"> {{ m__get_campaign_daily_quota_size() }}</div>
            </td>
            <td>
              <div class="shopee-overview-item-label"><i class="el-icon-chat-square"></i>
                {{ $t('center.ongoing_campaigns_with_total_budget') }}:
              </div>
              <div class="shopee-overview-item-value-1"> {{ m__get_campaign_total_quota_size() }}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div style="height: 30px"></div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="shopee-overview-item-label"><i class="el-icon-star-on"></i>
                {{ $t('center.sum_daily_budget') }}:
              </div>
              <div class="shopee-overview-item-value-1">{{ m__get_campaign_daily_quota() | currency }}</div>
            </td>
            <td>
              <div class="shopee-overview-item-label"><i class="el-icon-star-on"></i>
                {{ $t('center.sum_total_budget') }}:
              </div>
              <div class="shopee-overview-item-value-1">{{ m__get_campaign_total_quota() | currency }}</div>
            </td>
          </tr>
        </table>

        <br>
        <br>
        <el-tag v-if="c__show_display_campaign_list.length" type="danger" effect="dark" size="medium">
          {{ $t('center.optimize_or_pause_campaigns_note') }}
        </el-tag>
      </div>

      <el-row style="margin-top: 20px">
        <el-col :sm="12">
          <strong style="font-size: 16px">{{ $t('center.campaigns_with_low_performance') }}</strong>
        </el-col>
        <el-col :sm="12">
          <div style="display: flex; justify-content: right; gap: 10px">
            <el-select size="mini" value="" v-model="campaign_period" :disabled="loading.get_data"
                       @change="m__on_change_campaign_period()">
              <el-option :value="7" :label="$t('day.past7days')"></el-option>
              <el-option :value="30" :label="$t('day.past30days')"></el-option>
              <!--              <el-option :value="90" :label="$t('day.past90days')"></el-option>-->
            </el-select>
            <el-input v-if="$refs.campaign_component" v-model="$refs.campaign_component.search_keywords"
                      suffix-icon="el-icon-search" clearable size="mini" style="width: 250px"
                      :placeholder="$t('ads.placeholder_search_by')"></el-input>
          </div>
        </el-col>
      </el-row>
      <PasCampaignComponent ref="campaign_component"
                            :key="component_key"
                            :sp_user="seller"
                            :shop="shop"
                            :shopee_shop="shopee_shop"
                            :campaign_component.sync="campaign_component"
                            :campaign_type="'new_cpc_homepage_group'.replace('_group', '')"
                            :is_group="'new_cpc_homepage_group'.includes('_group')"
                            :date_range="date_range"
                            :start_date="start_date"
                            :end_date="end_date"
                            :parent_compare_date_range="date_range"
                            :is_full="false">
      </PasCampaignComponent>
    </div>
  </div>
</template>

<script>
import {
  minBy as _minBy,
  maxBy as _maxBy,
  drop as _drop,
  take as _take,
  orderBy as _orderBy
} from 'lodash'
import {base_flag, pas_base_flag} from '../../addon/options'
import store from '../../store/index'
import {get_shop_mixins} from "../../mixins/get_shop";
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {show_expr_notification} from "../../addon/check_license";
import PasCampaignComponent from "../pas/campaign.vue";
import {make_uuid} from "../../addon/ads_function";

export default {
  name: 'page__ads_center',

  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {
    PasCampaignComponent
  },

  data() {
    return {
      seller: null,
      loading: {
        get_data: false
      },

      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        pages: [10, 20, 30, 40, 50, 100]
      },

      campaign_filter: {
        page_size: 10,
        current_page: 0,
        total_record: 0,
        search_keywords: ''
      },

      cover: 'data:image/png;base64,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',
      item_count: 0,
      rating_sum: 0,
      rating_star: 0,
      display_response_rate: 0,
      response_time_value: this.$t('center.within_few_hours'),
      rating_count: [0, 0, 0, 0, 0, 0],
      cancel_rating: 0,
      min_price: 0,
      max_price: 0,

      product_list: [],
      product_tab: 'title',

      campaign_period: 7,
      campaign_list: [],
      flag_12: [...base_flag],
      flag_list: this.clone(pas_base_flag),
      is_compare_campaign: false,
      sort_option: {
        order: null,
        prop: null
      },
      component_key: null,
      date_range: [new Date(), new Date()],
      start_date: null,
      end_date: null,
      non_ads_data: {},
      ads_config: {},
      getting_campaigns: false,
      campaign_component: 'list'
    }
  },

  beforeRouteEnter(to, from, next) {
    if (store.state.advanced_ads_list.some(i => store.state.userInfo.username.includes(i))) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__on_change_campaign_period()
    await this.m__get_shopee_shop()
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    },
  },

  computed: {
    c__product_filter_list() {
      return this.product_list.filter(i => i.label.includes(this.product_tab))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)

      return _take(_drop(this.c__product_filter_list, skip), limit)
    },

    c__show_filter_campaign_list() {
      let result = this.campaign_list
        .filter(i => i.campaign.state === 'ongoing')
        .filter(i => i.report.broad_gmv.value === 0 || i.report.broad_cir.value > 0.2)

      // if (['ongoing', 'paused', 'ended'].includes(this.selected_state)) {
      //   result = result.filter(item => item.campaign.state === this.selected_state)
      // }
      //
      // if (this.selected_state === 'auto') {
      //   result = result.filter(item => (item.config_auto && item.config_auto.state === 'RUNNING') || item.auto_pause)
      // }
      //
      // if (this.selected_type) {
      //   result = result.filter(item => item.campaign.type === this.selected_type)
      // }
      //
      // if (this.filter_clone) {
      //   for (const item of this.filter_clone) {
      //     if (item.value) {
      //       item.is_percent === true
      //         ? result = result.filter(i => i.report && eval(`${i.report[item.camel_key].value * 100}${item.expression}${item.value}`))
      //         : result = result.filter(i => i.report && eval(`${i.report[item.camel_key].value}${item.expression}${item.value}`))
      //     }
      //   }
      // }

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.campaign_filter.search_keywords)
      return result.filter(item => this.remove_unicode(JSON.stringify(item)).includes(words))
    },

    c__show_display_campaign_list() {
      const limit = this.campaign_filter.page_size
      const skip = limit * (this.campaign_filter.current_page - 1)
      return _take(_drop(this.c__show_filter_campaign_list, skip), limit)
    }
  },

  methods: {
    async m__on_change_campaign_period() {
      if (this.campaign_period === 7) {
        this.date_range = [this.dayjs().subtract(7, 'day').toDate(), this.dayjs().toDate()]
      } else if (this.campaign_period === 30) {
        this.date_range = [this.dayjs().subtract(30, 'day').toDate(), this.dayjs().toDate()]
      } else if (this.campaign_period === 90) {
        this.date_range = [this.dayjs().subtract(90, 'day').toDate(), this.dayjs().toDate()]
      }

      if (this.date_range) {
        this.start_date = this.date_range[0]
        this.end_date = this.date_range[1]
      }

      if (this.shop.username) {
        this.seller = await this.init_seller(this.shop)
      }
      this.$nextTick(() => {
        if (this.$refs.campaign_component) {
          this.$refs.campaign_component.campaign_optimizer_selected = 'low'
        }
      })
    },

    m__short_value(value) {
      const one_thousand = 1000
      const one_million = one_thousand * one_thousand
      const one_billion = one_million * one_thousand

      let result = ''

      if (value >= one_billion) {
        result = `${(value / one_billion).toFixed(1)}b`
      } else if (value >= one_million) {
        result = `${(value / one_million).toFixed(1)}m`
      } else if (value >= one_thousand) {
        result = `${(value / one_thousand).toFixed(1)}k`
      } else {
        result = value
      }

      return result
    },

    m__get_ongoing_campaign() {
      // return this.campaign_list
      //   .filter(i => i.campaign.state === 'ongoing')
      //   .filter(i => i.report.broad_gmv.value === 0 || i.report.broad_cir.value > 0.1)
      //   .length

      if (this.$refs.campaign_component) {
        return this.$refs.campaign_component.campaign_list.length
      }

      return 0
    },

    m__get_campaign_total_quota_size() {
      // return this.campaign_list
      //   .filter(i => i.campaign.state === 'ongoing')
      //   .filter(i => i.report.broad_gmv.value === 0 || i.report.broad_cir.value > 0.1)
      //   .filter(i => +i.campaign.total_quota)
      //   .length

      if (this.$refs.campaign_component) {
        return this.$refs.campaign_component.campaign_list.filter(i => +i.campaign.total_quota).length
      }

      return 0
    },

    m__get_campaign_total_quota() {
      // return this.campaign_list
      //   .filter(i => i.campaign.state === 'ongoing')
      //   .filter(i => i.report.broad_gmv.value === 0 || i.report.broad_cir.value > 0.1)
      //   .filter(i => +i.campaign.total_quota)
      //   .reduce((t, i) => t + +i.campaign.total_quota, 0)


      if (this.$refs.campaign_component) {
        return this.$refs.campaign_component.campaign_list
          .filter(i => +i.campaign.total_quota)
          .reduce((t, i) => t + +i.campaign.total_quota, 0)
      }

      return 0
    },

    m__get_campaign_daily_quota_size() {
      // return this.campaign_list
      //   .filter(i => i.campaign.state === 'ongoing')
      //   .filter(i => i.report.broad_gmv.value === 0 || i.report.broad_cir.value > 0.1)
      //   .filter(i => +i.campaign.daily_quota)
      //   .length

      if (this.$refs.campaign_component) {
        return this.$refs.campaign_component.campaign_list.filter(i => +i.campaign.daily_quota).length
      }

      return 0
    },

    m__get_campaign_daily_quota() {
      // return this.campaign_list
      //   .filter(i => i.campaign.state === 'ongoing')
      //   .filter(i => i.report.broad_gmv.value === 0 || i.report.broad_cir.value > 0.1)
      //   .filter(i => +i.campaign.daily_quota)
      //   .reduce((t, i) => t + +i.campaign.daily_quota, 0)

      if (this.$refs.campaign_component) {
        return this.$refs.campaign_component.campaign_list
          .filter(i => +i.campaign.daily_quota)
          .reduce((t, i) => t + +i.campaign.daily_quota, 0)
      }

      return 0
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    },

    async m__pause_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      await this.seller.marketing_update_campaign_status([campaign.campaign.campaignid], 1)
      campaign.campaign.state = 'paused'
    },

    async m__ongoing_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      await this.seller.marketing_update_campaign_status([campaign.campaign.campaignid], 3)
      campaign.campaign.state = 'ongoing'
    },

    async m__restart_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      const response = await this.seller.marketing_get_campaign_detail(campaign.campaign.campaignid)
      await this.seller.marketing_update_campaign({
        ads_audit_event: 6,
        campaign_ads_list: [{
          advertisements: response.data.advertisements.filter(i => i.placement === 0),
          campaign: {
            ...response.data.campaign,
            start_time: this.dayjs().unix(),
            end_time: 0
          }
        }]
      })
      campaign.campaign.state = 'ongoing'
    },

    async m__stop_campaign(campaign) {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      await this.seller.marketing_update_campaign_status([campaign.campaign.campaignid], 2)
      campaign.campaign.state = 'ended'
    },

    m__get_report_property(campaign, key) {
      if (!campaign || !campaign.report) return '0'

      if (!campaign.report[key] || !campaign.report[key].value) return '0'

      return campaign.report[key].value > 0 ? campaign.report[key].value : '0'
    },

    m__get_report_property2(campaign, key) {
      if (!campaign || !campaign.c_report) return '0'

      if (!campaign.c_report[key] || !campaign.c_report[key].value) return '0'

      return campaign.c_report[key].value > 0 ? campaign.c_report[key].value : '0'
    },

    m__check_report_ratio(campaign, key) {
      if (!campaign || !campaign.report) return 0
      if (!campaign.report[key] || !campaign.report[key].ratio) return 0
      return +campaign.report[key].ratio
    },

    m__get_report_ratio(campaign, key) {
      if (!campaign || !campaign.report) return '-'

      if (!campaign.report[key] || !campaign.report[key].ratio) return '-'

      return +campaign.report[key].ratio !== 0 ? `${(+campaign.report[key].ratio * 100).toFixed(1)}%` : '-'
    },

    m__is_show_index(value) {
      const flag = this.flag_list.find(i => i.value === value)
      if (flag) {
        return flag.checked
      } else {
        return false
      }
    },

    async m__get_flag_list() {
      const resp = await this.seller.marketing_get_flag()
      const flag_list = resp.data.find(i => i.flag === 12)
      if (flag_list) {
        const flag_string = flag_list.value.replace(/[\[\]"]/ig, '')
        const flag_split = flag_string.split(',')
        for (const flag of this.flag_list) {
          flag.checked = flag_split.includes(flag.value)
        }
      }

      if (!this.flag_list.some(i => i.checked)) {
        for (const flag of this.flag_list) {
          if (['impression', 'click', 'ctr', 'cost', 'broadGmv'].includes(flag.value)) flag.checked = true
        }
      }
    },

    async m__get_campaign() {
      this.campaign_list = []

      const start_time = this.dayjs().subtract(this.campaign_period - 1, 'day').toDate()
      const end_time = new Date()

      let limit = 50, offset = 0
      let response = await this.seller.marketing_get_search_ads(start_time, end_time, offset, limit, 'ongoing')

      while (response && response.length > 0) {
        for (const item of response) {
          console.log(item.campaign.campaignid);
          if (item.campaign.campaignid === 145982184) {
            console.log(item);
          }

          for (const key of Object.keys(item.report)) {
            item.report[key].ratio = Number(item.report[key].ratio)
            item.report[key].value = Number(item.report[key].value)
          }
          item.report.atosa_cpc = {value: item.report.click.value !== 0 ? this.m__calculate(item.report.cost.value / item.report.click.value) : 0}
          item.loading = false
          item.checked = false
          item.label = []
        }
        this.campaign_list.push(...response)

        offset += limit
        response = await this.seller.marketing_get_search_ads(start_time, end_time, offset, limit, 'ongoing')
      }
    },

    m__get_optimizer_rating() {
      const y = this.product_list.filter(i => i.label.length).length
      const t = this.product_list.length

      return t ? Number((y * 100 / t).toFixed(0)) : 0
    },

    async m__confirm_update_product_name(product) {
      try {
        await this.$confirm(this.$t('base.change_product_name_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      await this.seller.update_product({
        id: product.id,
        name: product.seo
      })
      product.label = product.label.filter(i => i !== 'seo')
      this.ntf_s(this.$t('base.update_product_name_success'))
    },

    m__get_tab_length(label) {
      return this.product_list.filter(i => i.label.includes(label)).length
    },

    async m__get_shop_orders() {
      try {
        const all_resp = await this.seller.get_order_id_list()
        const all_total = all_resp.data.data.page_info.total
        const canceled_resp = await this.seller.get_canceled_order_id_list()
        // console.log(canceled_resp)
        const canceled_total = canceled_resp.data.data.page_info.total

        this.cancel_rating = all_total ? (canceled_total * 100 / all_total).toFixed(1) : 0
      } catch (e) {
        console.error(e)
      }
    },

    async m__get_shop_profile() {
      try {
        const decoration_get_draft_response = await this.seller.decoration_get_draft()
        // console.log('decoration_get_draft_response', decoration_get_draft_response)
        if (decoration_get_draft_response && decoration_get_draft_response.data) {
          const found = decoration_get_draft_response.data.decoration_data.find(i => i.data && i.data.shop_cover_image)
          if (found) this.cover = `https://cf.shopee.vn/file/${found.data.shop_cover_image}`
        }
        const get_chat_performance_response = await this.seller.get_chat_performance()
        // console.log('get_chat_performance_response', get_chat_performance_response)
        if (get_chat_performance_response) {
          this.display_response_rate = (+get_chat_performance_response.enquiry_resp_rate * 100).toFixed(2)
        }

        const search_shop_rating_comments_new_response = await this.seller.search_shop_rating_comments_new()
        // console.log('search_shop_rating_comments_new_response', search_shop_rating_comments_new_response)
        if (search_shop_rating_comments_new_response && search_shop_rating_comments_new_response.data) {
          const {
            five_star_count,
            four_star_count,
            three_star_count,
            two_star_count,
            one_star_count
          } = search_shop_rating_comments_new_response.data.counts
          this.rating_count = [five_star_count, four_star_count, three_star_count, two_star_count, one_star_count]
          this.rating_sum = five_star_count + four_star_count + three_star_count + two_star_count + one_star_count
          this.rating_star = ((five_star_count * 5) + (four_star_count * 4) + (three_star_count * 3) + (two_star_count * 2) + (one_star_count * 1)) / this.rating_sum
        }
      } catch (e) {
        console.error(e)
      }
    },

    async m__get_products() {
      this.product_list = []

      let page_index = 1
      let products_resp = await this.seller.get_product_by_page(page_index)
      // console.log(products_resp)
      while (products_resp.length) {
        for (const item of products_resp) {
          item.price = item.model_list && item.model_list.length && item.model_list[0].price_info ? +item.model_list[0].price_info.normal_price : 0
          item.label = []
          item.extra_data = {}

          item.seo = item.name.toLowerCase()
            .replace(/(^\w)|(\s\w)|(\[.*?])|(\(.*?\)|((^|\s)[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỂưạảấầẩẫậắằẳẵặẹẻẽềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễếệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]))/g, match => match.toUpperCase())

          if (item.name !== item.seo) {
            // item.label.push('seo')
          }
        }
        this.product_list.push(...products_resp)
        products_resp = await this.seller.get_product_by_page(page_index + 1)
        page_index++
      }
      this.min_price = _minBy(this.product_list, 'price').price
      this.max_price = _maxBy(this.product_list, 'price').price
      this.item_count = this.product_list.length

      // const optimizer_resp = await this.seller.get_listing_optimizer()
      // if (optimizer_resp.data && optimizer_resp.data.result && optimizer_resp.data.result.data) {
      //   const keys = ['title', 'image', 'description', 'shipping', 'category', 'weight']
      //   for (const key of keys) {
      //     if (optimizer_resp.data.result && optimizer_resp.data.result.data[key] &&
      //       optimizer_resp.data.result && optimizer_resp.data.result.data[key].list) {
      //       for (const item of optimizer_resp.data.result && optimizer_resp.data.result.data[key].list) {
      //         const found = this.product_list.find(i => i.id === item.itemid)
      //         if (found) {
      //           found.label.push(key)
      //           found.extra_data[key] = item
      //         }
      //       }
      //     }
      //   }
      // }
    },

    async m__initial_view() {
      this.loading.get_product = true
      try {
        if (this.shopee_shop.selected.length > 6) {
          const items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
          if (items.length > 0) {
            const shop = items[0]

            // todo: check role
            if (!this.check_role(shop, 'marketing', 'ads_center')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              this.product_list = []
              return
            }

            const json_data = await this.seller.get_shop_info()
            try {
              let current_info = json_data.data
              if (!current_info.shopid) {
                await this.seller.seller_login()
                await this.m__get_shopee_shop()
                const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
                this.seller.cookie = shop.cookie
                this.shop = shop
              }
            } catch (e) {
              await this.seller.seller_login()
              await this.m__get_shopee_shop()
              const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
              this.seller.cookie = shop.cookie
              this.shop = shop
            }

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)

            this.loading.get_data = true
            await Promise.all([
              this.m__get_shop_profile(),
              this.m__get_products(),
              // this.m__get_shop_orders(),
              // this.m__get_campaign(),
              // this.m__get_flag_list()
            ])
            this.loading.get_data = false
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
        this.loading.get_product = false
      }
    }
  }
}
</script>

<style lang="scss">
.shopee-cover {
  height: 187px;
  width: 100%;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  border-radius: 5px;
}

.shopee-overview-item-label {
  display: inline-block;
  font-size: 14px;

  i {
    font-size: 14px !important;
  }
}

.shopee-overview-item-value-1 {
  display: inline-block;
  font-size: 14px;
  color: tomato;
  font-weight: 600;
}

.shopee-overview-item-value-2 {
  display: inline-block;
  font-size: 14px;
  color: #3c8dbc;
  font-weight: 600;
}

.shopee-overview-rating {
  display: inline-block;
  margin-right: 15px;
  font-size: 14px;
  color: tomato;
  font-weight: 600;
}

.shopee-overview-horizontal {
  flex: 1;
  display: flex;
  flex-flow: column wrap;
}

.shopee-overview-horizontal-item {
  display: inline-block;
  flex: none;
}

.point-1 {
  display: inline-block;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  background-color: rgb(251, 115, 75);
}

.point-2 {
  background-color: rgb(54, 127, 227);
  display: inline-block;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/center/ads_center.vue